var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundedPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04199 9.99984C1.04199 5.05228 5.05277 1.0415 10.0003 1.0415C14.9479 1.0415 18.9587 5.05228 18.9587 9.99984C18.9587 14.9474 14.9479 18.9582 10.0003 18.9582C5.05277 18.9582 1.04199 14.9474 1.04199 9.99984ZM10.0003 2.2915C5.74313 2.2915 2.29199 5.74264 2.29199 9.99984C2.29199 14.257 5.74313 17.7082 10.0003 17.7082C14.2575 17.7082 17.7087 14.257 17.7087 9.99984C17.7087 5.74264 14.2575 2.2915 10.0003 2.2915Z",
    fill: "url(#paint0_linear_4120_6259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.0415C10.3452 6.0415 10.625 6.32133 10.625 6.6665V13.3332C10.625 13.6783 10.3452 13.9582 10 13.9582C9.65482 13.9582 9.375 13.6783 9.375 13.3332V6.6665C9.375 6.32133 9.65482 6.0415 10 6.0415Z",
    fill: "url(#paint1_linear_4120_6259)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04199 10C6.04199 9.65482 6.32181 9.375 6.66699 9.375H13.3337C13.6788 9.375 13.9587 9.65482 13.9587 10C13.9587 10.3452 13.6788 10.625 13.3337 10.625H6.66699C6.32181 10.625 6.04199 10.3452 6.04199 10Z",
    fill: "url(#paint2_linear_4120_6259)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4120_6259",
    x1: 17.5589,
    y1: 16.1587,
    x2: 3.00163,
    y2: 3.56104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4120_6259",
    x1: 10.5273,
    y1: 12.7212,
    x2: 8.78368,
    y2: 12.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4120_6259",
    x1: 13.3402,
    y1: 10.4297,
    x2: 12.9777,
    y2: 8.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedPlus);
export default __webpack_public_path__ + "static/media/rounded-plus.0ca2a5fcdd7f01468768c8d99adb43ae.svg";
export { ForwardRef as ReactComponent };